import { render } from "./CategoryPostView.vue?vue&type=template&id=e0b3967e"
import script from "./CategoryPostView.vue?vue&type=script&lang=js"
export * from "./CategoryPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__